export default __webpack_public_path__ + "static/media/image-banner-w.a32b6af8.png";